<div class="container-checkbox">
  <div *ngFor="let dt of dataList" class="checkbox">
    <label>
      <input type="checkbox" aria-label="Checkbox" (change)="selectOption($event,dt)">
      <span class="checkbox-material">
        <span class="check"></span>
      </span> {{dt.value}}
    </label>
  </div>
</div>
